import React from 'react';
import AlgoliaIcon from './AlgoliaIcon';
import AwsIcon from './AwsIcon';
import AwsLambdaIcon from './AwsLambdaIcon';
import BootstrapIcon from './BootstrapIcon';
import CloudflareIcon from './CloudflareIcon';
import ComposerIcon from './ComposerIcon';
import ConfluenceIcon from './ConfluenceIcon';
import Css3Icon from './Css3Icon';
import DockerIcon from './DockerIcon';
import EmailIcon from './EmailIcon';
import GithubIcon from './GithubIcon';
import GitlabIcon from './GitlabIcon';
import Html5Icon from './Html5Icon';
import JavascriptIcon from './JavascriptIcon';
import JenkinsIcon from './JenkinsIcon';
import JiraIcon from './JiraIcon';
import LinkedinIcon from './LinkedinIcon';
import MaterialUiIcon from './MaterialUiIcon';
import MysqlIcon from './MysqlIcon';
import NextDotJsIcon from './NextDotJsIcon';
import NotionIcon from './NotionIcon';
import NpmIcon from './NpmIcon';
import PhpIcon from './PhpIcon';
import PostgresqlIcon from './PostgresqlIcon';
import RaygunIcon from './RaygunIcon';
import ReactIcon from './ReactIcon';
import RedisIcon from './RedisIcon';
import ResumeIcon from './ResumeIcon';
import SassIcon from './SassIcon';
import SentryIcon from './SentryIcon';
import SlackIcon from './SlackIcon';
import SpeedcurveIcon from './SpeedcurveIcon';
import SymfonyIcon from './SymfonyIcon';
import TailwindcssIcon from './TailwindcssIcon';
import TwigIcon from './TwigIcon';
import TypescriptIcon from './TypescriptIcon';
import YarnIcon from './YarnIcon';

// Map des noms d'icônes vers les composants React
export const iconMap: Record<string, React.ComponentType> = {
  'algolia': AlgoliaIcon,
  'aws': AwsIcon,
  'aws-lambda': AwsLambdaIcon,
  'bootstrap': BootstrapIcon,
  'cloudflare': CloudflareIcon,
  'composer': ComposerIcon,
  'confluence': ConfluenceIcon,
  'css3': Css3Icon,
  'docker': DockerIcon,
  'email': EmailIcon,
  'github': GithubIcon,
  'gitlab': GitlabIcon,
  'html5': Html5Icon,
  'javascript': JavascriptIcon,
  'jenkins': JenkinsIcon,
  'jira': JiraIcon,
  'linkedin': LinkedinIcon,
  'material-ui': MaterialUiIcon,
  'mysql': MysqlIcon,
  'next-dot-js': NextDotJsIcon,
  'notion': NotionIcon,
  'npm': NpmIcon,
  'php': PhpIcon,
  'postgresql': PostgresqlIcon,
  'raygun': RaygunIcon,
  'react': ReactIcon,
  'redis': RedisIcon,
  'resume': ResumeIcon,
  'sass': SassIcon,
  'sentry': SentryIcon,
  'slack': SlackIcon,
  'speedcurve': SpeedcurveIcon,
  'symfony': SymfonyIcon,
  'tailwindcss': TailwindcssIcon,
  'twig': TwigIcon,
  'typescript': TypescriptIcon,
  'yarn': YarnIcon,
};
